import { render } from "./ReportStockDetailIndex.vue?vue&type=template&id=676190e7&scoped=true"
import script from "./ReportStockDetailIndex.vue?vue&type=script&lang=js"
export * from "./ReportStockDetailIndex.vue?vue&type=script&lang=js"

import "./ReportStockDetailIndex.vue?vue&type=style&index=0&id=676190e7&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676190e7"]])

export default __exports__